var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastDisabledLigth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 15.0712L16.364 14.364C19.873 10.8549 19.873 5.1452 16.364 1.63611L17.0711 0.928955C20.97 4.828 20.97 11.1721 17.0711 15.0712ZM0 11.0001H2.5V10.0001H1V6.00006H2.5V5.00006H0V11.0001ZM12 5.50006H14V10.5001H12V14.1938L3.5 11.3605V4.63965L12 1.80634V5.50006ZM11 3.19379L4.5 5.36035V10.6398L11 12.8063V3.19379ZM12 6.50006V9.50006H13V6.50006H12ZM16.3319 3.276L15.5253 3.86707C16.4083 5.07202 16.875 6.50122 16.875 8.00006C16.875 9.49884 16.4083 10.9279 15.5255 12.1328L16.3321 12.7239C17.3415 11.3463 17.875 9.71283 17.875 8.00006C17.875 6.28717 17.3414 4.65363 16.3319 3.276Z",
    fill: "#C1C7CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastDisabledLigth);
export default __webpack_public_path__ + "static/media/broadcast-disabled-ligth.d934e23b7bc3beb694d5b372a59272f8.svg";
export { ForwardRef as ReactComponent };